<template>
  <div>
    <SubKategoriPenyaluranDanaPopup :activate="active" @callback="callBackPopUp" />
    <vx-card>
      <!-- TABLE ACTION ROW -->
      <header class="w-full">
        <div class="mb-base mt-4 vx-row justify-between items-top">
          <section
            class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start"
          >
            <span class="text-black text-2xl">Tabel Sub-Kategori Penyaluran Dana</span>
          </section>
          <section
            class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-end"
          >
            <vs-button @click="active = true">Tambah Sub-Kategori</vs-button>
          </section>
        </div>
        <div class="vx-row justify-between items-center">
          <section class="mb-base vx-col md:w-2/5 lg:w-2/5 xl:w-2/5 sm:w-full">
            <div class="w-full gap-2 flex justify-start items-center">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <vs-button icon-after icon="expand_more">Aksi</vs-button>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item>
                    <span>Hapus</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div
                  class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <span class="mr-2">{{ `entries ${limit}` }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    v-for="(item, index) in limitDataTables"
                    :key="index"
                    @click="limit = item"
                  >
                    <span>{{ item }}</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </section>
          <section class="mb-base vx-col md:w-3/5 lg:w-3/5 xl:w-3/5 sm:w-full">
            <div class="w-full flex justify-end gap-2 flex-wrap items-center">
              <vs-input v-model="search" placeholder="Search..." />
            </div>
          </section>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div
          class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
        ></div>
      </header>

      <main>
        <vs-table
          stripe
          :data="subKategoris"
          v-model="selected"
          :max-items="limit"
          pagination
          multiple
        >
          <template slot="thead">
            <vs-th>Nama Sub-Kategori</vs-th>
            <vs-th>Parent Kategori</vs-th>
            <vs-th>Aksi</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].namaSubKategori">
                {{ data[indextr].namaSubKategori }}
              </vs-td>
              <vs-td :data="data[indextr].parentKategori">
                {{ data[indextr].parentKategori }}
              </vs-td>
              <vs-td>
                <div class="flex justify-start gap-2">
                  <vs-button
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-edit"
                  >
                  </vs-button>
                  <vs-button
                    color="danger"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-trash"
                  >
                  </vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </main>
    </vx-card>
  </div>
</template>

<script>
import SubKategoriPenyaluranDanaPopup from "@/views/dana/component/SubKategoriPenyaluranDanaPopup.vue";
import limitDataTables from "@/limitDataTable.js";

export default {
  components: {
    SubKategoriPenyaluranDanaPopup
  },
  data() {
    return {
      limitDataTables,
      limit: limitDataTables[0],
      active: false,
      selected: [],
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot"
      ],
      subKategoris: [
        {
          namaSubKategori: "Wabah Penyakit",
          parentKategori: "Bencana"
        },
        {
          namaSubKategori: "Kemiskinan",
          parentKategori: "Bencana"
        },
        {
          namaSubKategori: "Kebakaran",
          parentKategori: "Bencana"
        },
      ],
      search: ""
    };
  },
  methods: {
    callBackPopUp(val) {
      this.active = val;
    }
  }
};
</script>
